import React from 'react'
import Helmet from 'react-helmet'
import './proposeDetail.scss'
// import { ButtonBack } from '../../../components/newButton/newButton'
import UserImg from "../../../assets/user_logo.svg"
import Loading from '../../../components/loading/loading'
import * as emailjs from 'emailjs-com'
import { Mutation, Query } from "react-apollo"
import { ProposeId, ChangeStatus, UpdatePropose } from '../../../queries/propose'
import { GraphQLClient } from 'graphql-request'
import dayjs from 'dayjs'
import { endpoint } from '../../../queries/endpoint'
import Modal from '../../../components/Modal/modal'
import Input from "../../../components/newInput/input"
import Chat from '../../../components/chatWindow/chatWindow'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import Button from '../../../components/newButton/button'
import { TOOLS } from '../../../utilits/tools'
import ErrorM from '../../../components/ErrorMessange/errormenssage'
import Simplert from 'react-simplert'
import { Link } from 'react-router-dom'
import ErrorBoundary from '../../../components/errorBoundary/errorBoundary'
import * as totalvoice from 'totalvoice-node'
const clientSms = new totalvoice('7f2f6598051abf8dd72415cd20c4ee06')

export default class proposeDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            propose: '',
            loading: true,
            user: '',
            otherUser: '',
            loadingChat: true,
            chat: {},
            perfil: {},
            content: '',
            value: '',
            show: false,
            dateok: false,
            dateErr: null,
            valueok: false,
            valueErr: null,
            timeErr: null,
            date: [new Date(), new Date()],
            submitOK: false,
            showAlert: false,
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            impro: false,
            blocked: false,
            ranked: false,
            chatList: [],
            resposta: null
        }

        this.form = {}

        this.setInput = event => {
            this.setState({ value: event.target.value })
            return event.target.value
        } //_setInput

        this.showModal = e => {
            this.setState({
                show: !this.state.show
            })
        }

        this.setStatus = (ChangeStatus, e) => {
            // console.log(e)
            ChangeStatus({
                variables: {
                    id: this.proposeId,
                    status: e
                }
            }).then(
                res => {
                    // console.log(res.data.updatePropose)
                    const cache = JSON.parse(sessionStorage.getItem('OITO'))

                    const client = new GraphQLClient(endpoint, {
                        headers: {
                            Authorization: `Bearer ${cache.token}`,
                        },
                    })

                    if (res.data.updatePropose.status === "Serviço Finalizado com Sucesso") {
                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.playerId}",
                                title: "Solicitação finalizada com Sucesso!",
                                description: "Avalie como foi negociar com ${this.state.otherUser.name}.",
                                link: "/perfil/avaliacao/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Solicitação finalizada com Sucesso!",
                                description: "Entre e avalie como foi o serviço realizado.",
                                link: "/perfil/avaliacao/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Sua solicitação foi finalizada na Oito! Acesse oito.app e avalie o serviço realizado. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params = {
                            "email": this.state.otherUser.email,
                            "title": "Solicitação finalizada!",
                            "name": this.state.otherUser.name,
                            "message": "Seu serviço foi finalizado. Entre e avalie como foi."
                        }

                        emailjs.send('noreply', 'default', template_params, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação finalizada com Sucesso!',
                            messageAlert: 'Avalie como foi trabalhar para seu cliente.',
                            onClose: () => window.location.href = '/perfil/avaliacao/' + this.proposeId
                        })

                        this.form = {}
                        this.refetch()

                    } else if (res.data.updatePropose.status === "Serviço Recusado") {
                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Solicitação recusada!",
                                description: "O profissional analisou a sua solicitação e recusou.",
                                link: "/perfil/proposedetails/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Sua solicitação foi recusada na Oito! Acesse Oito.app e procure outros profissionais para realizar seu serviço. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params2 = {
                            "email": this.state.otherUser.email,
                            "title": "Solicitação recusada!",
                            "name": this.state.otherUser.name,
                            "message": "O profissional analisou a sua solicitação e recusou. Mas não se preocupe - é só voltar para a OITO e encontrar outro profissional disponível para fazer o trabalho."
                        }

                        emailjs.send('noreply', 'default', template_params2, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação recusada!',
                            messageAlert: 'Você recusou a solicitação. Não será mais possível alterá-la.',
                            onClose: () => window.location.href = '/perfil/avaliacao/' + this.proposeId + '?noresponse'
                        })

                        this.form = {}
                        this.refetch()

                    } else if (res.data.updatePropose.status === "Serviço Aceito") {
                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Solicitação aceita!",
                                description: "Agora é só aguardar que o trabalho seja feito.",
                                link: "/perfil/proposedetails/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Sua solicitação foi aceita na Oito! Agora é só aguardar que o trabalho seja feito. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params3 = {
                            "email": this.state.otherUser.email,
                            "title": "Solicitação aceita!",
                            "name": this.state.otherUser.name,
                            "message": "A sua solicitação foi analisada pelo profissional e ele fechou com você! Agora é só aguardar que o trabalho seja feito e avaliar o desempenho através da Oito."
                        }

                        emailjs.send('noreply', 'default', template_params3, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação aceita!',
                            messageAlert: 'Não se esqueça de realizar o serviço como combinado.',
                            onClose: () => window.location.href = '/perfil/proposedetails/' + this.proposeId
                        })

                        this.form = {}
                        this.refetch()

                    } else if (res.data.updatePropose.status === "Serviço Aberto para Negociação") {
                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Solicitação aberto para negociação!",
                                description: "Sua solicitação está aberta para negociação.",
                                link: "/perfil/proposedetails/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Sua solicitação está aberta para negociação na Oito! Acesse oito.app e feche negócio o quanto antes. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params4 = {
                            "email": this.state.otherUser.email,
                            "title": "Solicitação aberta para negociação!",
                            "name": this.state.otherUser.name,
                            "message": "A sua solicitação foi analisada pelo profissional, foi aceita e agora está aberta para negociação. Entre em contato com o profissional através da Oito e acerte os detalhes para fechar o trabalho!"
                        }

                        emailjs.send('noreply', 'default', template_params4, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação aberta para negociação!',
                            messageAlert: 'Negocie com seu cliente as condições perfeitas para as duas partes.',
                            onClose: () => window.location.href = '/perfil/proposedetails/' + this.proposeId
                        })

                        this.form = {}
                        this.refetch()

                    } else if (res.data.updatePropose.status === "Serviço Cancelado") {
                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Serviço cancelada!",
                                description: "Por algum motivo sua solicitação foi cancelada. Avalie como foi a negociação.",
                                link: "/perfil/avaliacao/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Sua solicitação foi cancelada na Oito! Acesse oito.app e procure outros profissionais para realizar seu serviço. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params5 = {
                            "email": this.state.otherUser.email,
                            "title": "Solicitação cancelada!",
                            "name": this.state.otherUser.name,
                            "message": "A sua solicitação foi cancelada! Abra outra pela Oito e continue procurando o profissional perfeito para o trabalho."
                        }

                        emailjs.send('noreply', 'default', template_params5, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.form = {}

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação cancelada!',
                            messageAlert: 'Você cancelou a solicitação. Avalie seu cliente.',
                            onClose: () => window.location.href = '/perfil/avaliacao/' + this.proposeId + '?noresponse'
                        })

                    } else if (res.data.updatePropose.status === "Serviço Não Realizado") {
                        if (this.state.impro) {
                            this.form.profId = this.playerId
                            this.form.profName = cache.user.player.name
                            this.form.profEmail = cache.user.player.email
                            this.form.profPhone = cache.user.player.phone
                            this.form.cliId = this.state.otherUser.id
                            this.form.cliName = this.state.otherUser.name
                            this.form.cliEmail = this.state.otherUser.email
                            this.form.cliPhone = this.state.otherUser.phone
                        } else {
                            this.form.cliId = this.playerId
                            this.form.cliName = cache.user.player.name
                            this.form.cliEmail = cache.user.player.email
                            this.form.cliPhone = cache.user.player.phone
                            this.form.profId = this.state.otherUser.id
                            this.form.profName = this.state.otherUser.name
                            this.form.profEmail = this.state.otherUser.email
                            this.form.profPhone = this.state.otherUser.phone
                        }

                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.form.profId}",
                                title: "Solicitação encerrada!",
                                description: "Você não respondeu e a sua solicitação foi encerrada. Avalie como foi negociar com ${this.form.cliName}.",
                                link: "/perfil/avaliacao/${this.proposeId}?noresponse",
                                ){
                                id
                                title
                                }
                                } `)

                        client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.form.cliId}",
                                title: "Solicitação encerrada!",
                                description: "Você não respondeu e a sua solicitação foi encerrada. Avalie como foi negociar com ${this.form.profName}.",
                                link: "/perfil/avaliacao/${this.proposeId}?noresponse",
                                ){
                                id
                                title
                                }
                                } `)

                        const phone = this.state.otherUser.phone.replace("(", "").replace(")", "").replace(" ", "").replace("-", "").replace("+55", "")
                        // console.log(phone)
                        console.log("enviando msg")
                        clientSms.sms.enviar(phone, "Você não respondeu e a sua solicitação foi encerrada na Oito. Acesse oito.app e não deixe de responder para não ficar com avaliação baixa. Oito App")
                            .then(function (data) {
                                // console.log(data)
                                console.log("sms enviado")
                            })
                            .catch(function (error) {
                                console.error('Erro: ', error)
                            });

                        //enviar email
                        var template_params6 = {
                            "email": this.state.impro ? this.form.cliEmail : this.form.profEmail,
                            "title": "Solicitação encerrada!",
                            "name": this.state.impro ? this.form.cliName : this.form.profName,
                            "message": this.state.impro ? "Você não respondeu o profissional e a sua solicitação foi encerrada. Você pode abrir outra pela Oito, mas fique de olho no contato para não perder mais uma oportunidade ou ficar com a avaliação baixa." : "Você não respondeu o cliente em tempo e a sua solicitação foi encerrada. Você pode receber outras solicitação pela Oito, mas fique de olho no contato para não perder mais uma oportunidade ou ficar com a avaliação baixa."
                        }

                        emailjs.send('noreply', 'default', template_params6, "user_IagwdTtEr3AVRdLhxkyKc")
                            .then((response) => {
                                console.log('SUCCESS!', response.status, response.text)
                                this.form = {}
                            }, function (error) {
                                console.log('FAILED...', error);
                            })

                        this.form = {}

                        this.setState({
                            loadingE: false,
                            showAlert: true,
                            typeAlert: 'success',
                            titleAlert: 'Solicitação encerrada!',
                            messageAlert: `Avalie o ${this.state.impro ? "cliente" : "profissional"}.`,
                            onClose: () => window.location.href = '/perfil/avaliacao/' + this.proposeId + '?noresponse'
                        })


                    }
                }
            )
        }

        this.realValue = e => {
            this.setState({ showAlert: false, valueok: false, valueErr: null })
            if (e.target.value) {
                this.form.valueEnd = TOOLS.formatReal(parseInt(TOOLS.onlyNumbers(e.target.value)))
                this.setState({ valueok: true, valueErr: null })
            } else {
                this.form.valueEnd = "0,00"
                this.setState({
                    valueok: false,
                    valueErr: <ErrorM color="danger" content='Digite o valor que você pretende pagar pelo serviço.' />
                })
            }
            return (e.target.value = "R$ " + this.form.valueEnd)
        }

        this.timeValue = e => {
            this.setState({ timeErr: null })
            // console.log(e.target.name)
            if (e.target.value) {
                this.form[`${e.target.name}`] = TOOLS.formatTime(parseInt(TOOLS.onlyNumbers(e.target.value)))
                this.setState({ timeErr: null })

                if (e.target.value === "00:00" || e.target.value === "0") this.setState({
                    timeErr: <ErrorM color="warning" content='Não é obrigatório, mas seria legal informar o horário que você precisa do serviço. Ele pode ser alterado depois.' />
                })
            } else {
                this.form[`${e.target.name}`] = "00:00"
                this.setState({
                    timeErr: <ErrorM color="warning" content='Não é obrigatório, mas seria legal informar o horário que você precisa do serviço. Ele pode ser alterado depois.' />
                })
            }

            return this.form[`${e.target.name}`]
        }

        this.onChangedata = date => {
            this.setState({ showAlert: false, date, dateErr: null, dateok: false })
            console.log(date)
            if (date) {
                this.form.dateInitF = date[0]
                this.form.dateEndF = date[1]

                // console.log(this.form)

                // console.log(dayjs().isSameOrBefore(this.form.dateInit))

                // console.log(dayjs().isBefore(this.form.dateInit) && dayjs(this.form.dateInit).isBefore(this.form.dateEnd))
                if (dayjs().isSameOrBefore(this.form.dateInitF) && dayjs(this.form.dateInitF).isSameOrBefore(this.form.dateEndF)) {
                    this.setState({ dateok: true, dateErr: null })
                } else {
                    this.setState({
                        dateok: false,
                        dateErr: <ErrorM color="danger" content='Você não pode enviar uma proposta com a data de hoje ou anterior.' />
                    })
                }


            } else {
                this.form.dateInitF = ''
                this.form.dateEndF = ''
                this.setState({
                    dateok: false,
                    dateErr: <ErrorM color="danger" content='É necessário escolher uma data. Ela pode ser alterada depois.' />
                })
            }
        }

        this.setDescription = event => {
            this.setState({ value: event.target.value });
            this.form[`${event.target.name}`] = event.target.value
            return this.state.value
        } //_setInput

        this.sendPropose = UpdatePropose => {
            this.setState({ loadingE: true })
            // console.log(this.form)

            if (!this.form.valueEnd) this.form.valueEnd = this.state.propose.valueInit
            if (!this.form.dateInitF) this.form.dateInitF = this.state.propose.dateInit
            if (!this.form.dateEndF) this.form.dateEndF = this.state.propose.dateEnd
            if (!this.form.timeInitF) this.form.timeInitF = this.state.propose.timeInit
            if (!this.form.timeEndF) this.form.timeEndF = this.state.propose.timeEnd
            if (!this.form.location) this.form.location = this.state.propose.location

            // console.log(this.form)

            const descricao = this.form.description !== undefined ? this.form.descriptionOld + " ------- " + this.form.description : this.form.descriptionOld
            UpdatePropose({
                variables: {
                    id: this.proposeId,
                    valueEnd: this.form.valueEnd,
                    dateInitF: this.form.dateInitF,
                    dateEndF: this.form.dateEndF,
                    timeInitF: this.form.timeInitF,
                    timeEndF: this.form.timeEndF,
                    location: this.form.location,
                    description: descricao
                }
            }).then(
                res => {
                    this.showModal()
                    const cache = JSON.parse(sessionStorage.getItem('OITO'))
                    const date = new Date()
                    const now = date.toISOString()

                    const client = new GraphQLClient(endpoint, {
                        headers: {
                            Authorization: `Bearer ${cache.token}`,
                        },
                    })

                    client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.playerId}",
                                title: "Proposta alterada!",
                                description: "Aguarde o cliente aceitar sua proposta para fechar a negociação.",
                                link: "/perfil/proposedetails/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                    client.request(`
                                mutation{
                                createNotification(
                                userId: "${this.state.otherUser.id}",
                                title: "Proposta alterada!",
                                description: "Entre e confira as alterações para aceitar e fechar a proposta.",
                                link: "/perfil/proposedetails/${this.proposeId}",
                                ){
                                id
                                title
                                }
                                } `)

                    //enviar email
                    var template_params = {
                        "email": this.state.otherUser.email,
                        "title": "Proposta alterada!",
                        "name": this.state.otherUser.name,
                        "message": "Entre e confira as alterações para aceitar e fechar a proposta."
                    }

                    emailjs.send('noreply', 'default', template_params, "user_IagwdTtEr3AVRdLhxkyKc")
                        .then((response) => {
                            console.log('SUCCESS!', response.status, response.text)
                            this.setState({
                                loadingE: false,
                                showAlert: true,
                                typeAlert: 'success',
                                titleAlert: 'Proposta alterada!',
                                messageAlert: 'Agora, aguarde o cliente aceitar as alterações.',
                                onClose: () => window.location.reload()
                            })
                            this.form = {}
                        }, function (error) {
                            console.log('FAILED...', error);
                            // this.setState({
                            //     loading: false,
                            //     showAlert: true,
                            //     typeAlert: 'error',
                            //     titleAlert: 'Erro!',
                            //     messageAlert: 'Ocorreu algum problema. Tente novamente.'
                            // })
                        })
                    this.setState({
                        loadingE: false,
                        showAlert: true,
                        typeAlert: 'success',
                        titleAlert: 'Proposta alterada!',
                        messageAlert: 'Agora, aguarde o cliente aceitar as alterações.',
                        onClose: () => window.location.reload()
                    })
                    this.form = {}
                }
            )
        }

        this.acceptPropose = () => {
            this.setState({ loading: true })
            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            client.request(`
                                mutation{
                                    updatePropose(
                                        id: "${this.proposeId}",
                                        input: {
                                            aceite: ${true},
                                            status: "Serviço Aceito"
                                        }){
                                            id
                                        }
                                } `).then(
                res => {
                    console.log(res)
                    window.location.reload()
                }
            )

        }
    }

    getTime(data) {
        if (data && this.state.resposta === null) {
            this.setState({ resposta: data })
        }
    }

    render() {

        this.proposeId = window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)]
        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if (!cache) {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado!',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        } else {
            this.playerId = cache.user.id
        }

        return (
            <div className="col-xs-12" style={{ maxWidth: '980px' }}>
                <Helmet>
                    {/* <title>Oito - Detalhe da Solicitação</title> */}
                    <meta name="title" content="Oito.app | Confira detalhes das solicitações recebidas em Oito.app" />
                    <meta name="description" content="Negocie diretamente com seu cliente ou prestador de serviços. Confira os detalhes das solicitações, entenda as condições e dê sequência à negociação" />
                    <meta name="keywords" content="Negociação, Solicitações, Oportunidades" />
                    <meta name="robots" content="index, follow" />
                    <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="Portuguese" />
                    <meta name="revisit-after" content="1 days" />
                </Helmet>

                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />

                <div className="row">
                    <div className="col-xs-12" style={{ textAlign: "left" }}>
                        <h1 style={{ margin: '5px 0' }}>Chat</h1>
                        <span>Negocie diretamente com o {this.state.impro ? "cliente" : "profissional"}</span>
                        {this.state.resposta !== null ? <p style={{ textAlign: "right", }}><small>tempo médio de resposta: {parseInt(this.state.resposta)} minutos</small></p> : null}
                    </div>

                    <Query query={ProposeId} variables={{ id: this.proposeId }}>
                        {({ loading, error, data, refetch }) => {
                            if (loading) return <Loading />
                            if (error) return <p>{error.message}</p>

                            this.refetch = refetch
                            // console.log(data)
                            let otherUser = {}
                            if (data.propose) {
                                const propose = data.propose
                                // console.log(propose)
                                if (data.propose.from.id === this.playerId) {
                                    // console.log("nao setar impro")
                                    otherUser = data.propose.to
                                } else {
                                    otherUser = data.propose.from
                                    // console.log(" setar impro")
                                    if (!this.state.impro) {
                                        this.setState({ impro: true })
                                    }
                                }

                                if (this.state.otherUser === '') this.setState({ otherUser: otherUser })
                                if (this.state.propose === '') this.setState({ propose: propose })

                                // console.log(propose)

                                if (propose.status === "Serviço Não Realizado" ||
                                    propose.status === "Serviço Recusado" ||
                                    propose.status === "Serviço Cancelado" ||
                                    propose.status === "Serviço Finalizado com Sucesso") {
                                    propose.ranks.map(user => (
                                        (user.from.id === this.playerId) ?
                                            !this.state.ranked ? this.setState({ ranked: true }) : null : null
                                    ))
                                    if (!this.state.blocked) this.setState({ blocked: true })
                                }
                                // console.log('set otheruser')

                                let noresponse = false

                                if (propose.status === "Serviço Não Realizado" ||
                                    propose.status === "Serviço Recusado" ||
                                    propose.status === "Serviço Cancelado") {
                                    noresponse = true
                                }


                                // console.log(this.state.chatList)
                                this.form.descriptionOld = propose.description

                                return (
                                    <div className="propose-detail col-xs-12">
                                        <div className="row center-xs">
                                            <div className={'chat col-xs-12 col-sm-8'}>
                                                <ErrorBoundary><Chat propose={this.state.propose} blocked={this.state.blocked} otherUser={this.state.otherUser} callbackFunctions={this.getTime.bind(this)} /></ErrorBoundary>
                                            </div>

                                            <Simplert
                                                showSimplert={(!propose.aceite && propose.valueEnd && !this.state.impro) ? true : false}
                                                type='info'
                                                title='Solicitação alterada'
                                                message={`<p>Sua solicitação foi alterada pelo profissional.</p>
                                        <p>Confira as alterações e, se estiver de acordo, clique em "Aceitar".</p>
                                        <table>
                                            <thead>
                                                <tr>
                                                <th scope="col"></th>
                                                <th scope="col">Proposto</th>
                                                <th scope="col">Solicitado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Valor</th>
                                                    <td class='tabletext'>${propose.valueInit === null ? "--" : propose.valueInit}</td>
                                                    <td class=${propose.valueInit === propose.valueEnd ? 'tabletext' : 'changed'}>${propose.valueEnd}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Data</th>
                                                    <td class='tabletext'>${dayjs(propose.dateInit).format("DD/MM/YYYY") === dayjs(propose.dateEnd).format("DD/MM/YYYY") ? dayjs(propose.dateInit).format("DD/MM/YYYY") : dayjs(propose.dateInit).format("DD/MM/YYYY")+"-"+dayjs(propose.dateEnd).format("DD/MM/YYYY")}</td>
                                                    <td class=${(propose.dateInit === propose.dateInitF && propose.dateEnd === propose.dateEndF) ? 'tabletext' : 'changed'}>${dayjs(propose.dateInitF).format("DD/MM/YYYY") === dayjs(propose.dateEndF).format("DD/MM/YYYY") ? dayjs(propose.dateInitF).format("DD/MM/YYYY") : dayjs(propose.dateInitF).format("DD/MM/YYYY")+"-"+dayjs(propose.dateEndF).format("DD/MM/YYYY")}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Horário</th>
                                                    <td class='tabletext'>${propose.timeInit}-${propose.timeEnd}</td>
                                                    <td class=${(propose.timeInit === propose.timeInitF && propose.timeEnd === propose.timeEndF) ? 'tabletext' : 'changed'}>${propose.timeInitF}-${propose.timeEndF}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Local</th>
                                                    <td class='tabletext'>${propose.location === null ? "" : propose.location}</td>
                                                    <td class=${(propose.location === propose.locationF) ? 'tabletext' : 'changed'}>${propose.locationF === null ? "" : propose.locationF}</td>
                                                </tr>
                                            </tbody>
                                        </table>`}
                                                customCloseBtnText='Negociar novamente'
                                                customCloseBtnClass={this.state.customCloseBtnClass}
                                                onClose={this.state.onClose}
                                                useConfirmBtn={true}
                                                onConfirm={() => this.acceptPropose()}
                                                customConfirmBtnText='Aceitar'
                                                customConfirmBtnClass='buttonconfirm'
                                            />

                                            <div className={'info col-xs-12 col-sm-4'}>
                                                <div className='header'>
                                                    {/*<div className="skill">*/}
                                                    {/*    <h1>{propose.skill}</h1>*/}
                                                    {/*</div>*/}
                                                    <Link to={this.state.impro ? `/profileClient/${this.state.otherUser.id}` : `/profile/${this.state.otherUser.id}`} >
                                                        <figure><img src={this.state.otherUser.photo ? this.state.otherUser.photo.url : this.state.otherUser.avatar ? this.state.otherUser.avatar : UserImg} alt={this.state.otherUser.name} /></figure>
                                                        <span>{this.state.otherUser.name}</span>
                                                    </Link>
                                                </div>

                                                <div className={'content'}>

                                                    {this.state.blocked ? this.state.ranked ? null : <p><Link to={!noresponse ? `/perfil/avaliacao/${this.proposeId}` : `/perfil/avaliacao/${this.proposeId}?noresponse`}><Button type="button" name={!noresponse ? "Avaliar serviço" : this.state.impro ? "Avaliar cliente" : "Avaliar profissional"} /></Link></p> :
                                                        <p>{(this.state.impro && !propose.aceite) ? <Button type="button" disabled={this.state.blocked} onClick={() => this.setState({ show: !this.state.show })} name="Alterar proposta" /> :
                                                            (!propose.aceite && propose.valueEnd) ? <Button type="button" disabled={this.state.blocked} name="Aceitar proposta" /> : null}</p>}



                                                    <span style={{ display: "flex", alignItems: 'center', margin: '10px 0' }}>
                                                        <svg style={{ width: '24px', height: '24px', marginRight: '10px' }} viewBox="0 0 24 24">
                                                            <path fill="#5f5f5f" d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" />
                                                        </svg>
                                                        {propose.aceite ?
                                                            (dayjs(propose.dateInitF).format("DD/MM/YYYY").toString() === dayjs(propose.dateEndF).format("DD/MM/YYYY").toString() ?
                                                                `${dayjs(propose.dateInitF).format("DD/MM/YYYY")}` :
                                                                `${dayjs(propose.dateInitF).format("DD/MM/YYYY")} - ${dayjs(propose.dateEndF).format("DD/MM/YYYY")}`) :
                                                            (dayjs(propose.dateInit).format("DD/MM/YYYY").toString() === dayjs(propose.dateEnd).format("DD/MM/YYYY").toString() ?
                                                                `${dayjs(propose.dateInit).format("DD/MM/YYYY")}` :
                                                                `${dayjs(propose.dateInit).format("DD/MM/YYYY")} - ${dayjs(propose.dateEnd).format("DD/MM/YYYY")}`)}
                                                        {((!propose.aceite && propose.valueEnd) && (propose.dateInit !== propose.dateInitF || propose.dateEnd !== propose.dateEndF)) ?
                                                            <span>  / <span className='changed'>
                                                                {dayjs(propose.dateInitF).format("DD/MM/YYYY").toString() === dayjs(propose.dateEndF).format("DD/MM/YYYY").toString() ?
                                                                    `${dayjs(propose.dateInitF).format("DD/MM/YYYY")}` :
                                                                    `${dayjs(propose.dateInitF).format("DD/MM/YYYY")} - ${dayjs(propose.dateEndF).format("DD/MM/YYYY")}`}</span></span>
                                                            : null}
                                                    </span>

                                                    <span style={{ display: "flex", alignItems: 'center', margin: '10px 0', color: '#13b323' }}>
                                                        <svg style={{ width: '24px', height: '24px', marginRight: '10px' }} viewBox="0 0 24 24">
                                                            <path fill="#13b323" d="M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z" />
                                                        </svg>
                                                        R$ {propose.aceite ? propose.valueEnd : (propose.valueInit === null ? "--" : propose.valueInit)}
                                                        {((!propose.aceite && propose.valueEnd) && (propose.valueInit !== propose.valueEnd)) ?
                                                            <span>  / <span className='changed'>R$ {propose.valueEnd}</span></span>
                                                            : null}
                                                    </span>

                                                    <span style={{ display: "flex", alignItems: 'center', margin: '10px 0' }}>
                                                        <svg style={{ width: '22px', height: '22px', marginRight: '10px' }} viewBox="0 0 24 24">
                                                            <path fill="#5f5f5f" d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                                                        </svg>
                                                        {propose.aceite ? `${propose.timeInitF} - ${propose.timeEndF}` : propose.timeInit !== null && propose.timeEnd !== null ? `${propose.timeInit} - ${propose.timeEnd}` : null}
                                                        {((!propose.aceite && propose.valueEnd) && (propose.timeInit !== propose.timeInitF || propose.timeEnd !== propose.timeEndF) && (propose.timeInit !== null && propose.timeEnd !== null)) ?
                                                            <span>  / <span className='changed'>{propose.timeInitF} - {propose.timeEndF}</span></span>
                                                            : null}
                                                    </span>

                                                    <span style={{ display: "flex", alignItems: 'center', margin: '10px 0' }}>
                                                        <svg style={{ width: '24px', height: '24px', marginRight: '10px' }} viewBox="0 0 24 24">
                                                            <path fill="#5f5f5f" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
                                                        </svg>
                                                        {propose.aceite ? propose.valueEnd : (propose.location === null ? "--" : propose.location)}
                                                        {((!propose.aceite && propose.locationF) && (propose.locationF !== propose.location)) ?
                                                            <span>  / <span className='changed'>{propose.locationF}</span></span>
                                                            : null}
                                                    </span>


                                                    <h3>Descrição</h3>
                                                    <p>{propose.description}</p>

                                                    <div className={'status'}>
                                                        <Mutation mutation={ChangeStatus}>
                                                            {(ChangeStatus, { loading, error }) => {
                                                                if (loading) return <Loading />
                                                                if (error) console.log(error.message)
                                                                return <select id="dropdown" style={{ border: 'none', color: '#5f5f5f' }} onChange={(e) => e.target.value !== propose.status ? this.setStatus(ChangeStatus, e.target.value) : null} disabled={this.state.blocked}>
                                                                    <option value={propose.status}>{propose.status}</option>
                                                                    <option value="Serviço Não Realizado">Serviço Não Realizado</option>
                                                                    {this.state.impro ? (propose.status === "Serviço Aberto para Negociação" ? <option value="Serviço Recusado">Serviço Recusado</option> : null) : null}
                                                                    {this.state.impro ? (propose.status === "Serviço Aberto para Negociação" ? <option value="Serviço Aceito">Serviço Aceito</option> : null) : null}
                                                                    {this.state.impro ? (propose.status === "Serviço Aberto para Negociação" || propose.status === "Serviço Aceito" ? <option value="Serviço Cancelado">Serviço Cancelado</option> : null) : null}
                                                                    {this.state.impro ? (propose.status === "Serviço Aberto para Negociação" || propose.status === "Serviço Aceito" ? <option value="Serviço Finalizado com Sucesso">Serviço Finalizado com Sucesso</option> : null) : null}
                                                                </select>
                                                            }}
                                                        </Mutation>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {/* <div className='content-info row'> */}
                                        <Modal show={this.state.show} onClose={this.showModal} title='Detalhes'>
                                            <p style={{ textAlign: "left" }}>Antes de fechar negócio, confirme os detalhes.</p>
                                            <form id="formpropose" className="row middle-xs">
                                                <div className="col-xs-12 col-sm-6">
                                                    <Input name="valueEnd" label='Valor fechado' placeholder={"Valor fechado"} type="text" onKeyUp={this.realValue} defaultValue={this.form.valueEnd ? this.form.valueEnd : (propose.valueInit === null ? "--" : propose.valueInit)} />
                                                    {this.state.valueErr}
                                                </div>

                                                <div className="col-xs-12 col-sm-6">
                                                    Data:
                                                    <DateRangePicker onChange={this.onChangedata} value={this.state.date} minimumDate={dayjs().add(1, 'day')} initialDate={dayjs().add(1, 'day')} className='inputStyleGrey' required />
                                                    {this.state.dateErr}
                                                </div>

                                                {/* <div className="row col-xs-12"> */}
                                                    <div className="col-sm-6 col-xs-12">
                                                        <Input name="timeInitF" label='Horário de início' placeholder={"Horário de início"} type="text" onKeyUp={this.timeValue} defaultValue={this.form.timeInitF ? this.form.timeInitF : propose.timeInit} maxlength={6} />
                                                    </div>

                                                    <div className="col-sm-6 col-xs-12">
                                                        <Input name="timeEndF" label='Horário de encerramento' placeholder={"Horário de encerramento"} type="text" onKeyUp={this.timeValue} defaultValue={this.form.timeEndF ? this.form.timeEndF : propose.timeEnd} maxlength={6} />
                                                    </div>
                                                    {this.state.timeErr}
                                                {/* </div> */}

                                                <div className="col-xs-12">
                                                    <Input name="location" placeholder="Local. Ex.: Cidade - Estado" type="text" onInput={this.setDescription} maxlength={100} />
                                                </div>

                                                <div className="col-xs-12">
                                                    <Input name="description" placeholder="Digite aqui informações adicionais" type="text" onInput={this.setDescription} maxlength={254} />
                                                </div>

                                                {this.state.loadingE ? <Loading /> :
                                                    <div className="col-xs-12">
                                                        <Mutation mutation={UpdatePropose}>
                                                            {(UpdatePropose, { loading, error }) => {
                                                                if (loading) return <Loading />
                                                                if (error) return console.log(UpdatePropose.error)
                                                                return <Button
                                                                    name='Enviar solicitação'
                                                                    type='submit'
                                                                    disabled={this.state.dateok ? false : true}
                                                                    onClick={() => this.sendPropose(UpdatePropose)}
                                                                />
                                                            }}
                                                        </Mutation>
                                                    </div>}
                                            </form>
                                        </Modal>

                                        {/* <p><span><i className="fas fa-clock"></i>{propose.aceite ? `${propose.timeInitF} - ${propose.timeEndF}` : `${propose.timeInit} - ${propose.timeEnd}`}</span>*/}
                                        {/* {((!propose.aceite && propose.valueEnd) && (propose.timeInit !== propose.timeInitF || propose.timeEnd !== propose.timeEndF)) ?*/}
                                        {/* <span>  / <span className='changed'>{propose.timeInitF} - {propose.timeEndF}</span></span>*/}
                                        {/* : null}</p> */}
                                    </div>
                                )
                            } else {
                                return null
                            }
                        }}
                    </Query>
                </div>

            </div >
        )
    }
}
